import { ActivatedRouteSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoginResponseData } from 'src/app/interfaces/LoginResponseData';

@Injectable({ providedIn: 'root' })
export class StatGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    let statusResponse: Observable<LoginResponseData> =
      await this.authService.checkStatus();
    let returnValue: Promise<boolean | UrlTree> = statusResponse
      .pipe(
        map((res: LoginResponseData) => {
          if (res.status == 1 || res.status == 2) {
            // With flat routes, we don't need to check route parameters
            // The route itself determines access
            return true;
          } else if (res.status == 0) {
            return this.router.createUrlTree(['/']);
          } else {
            return false;
          }
        }),
      )
      .toPromise() as Promise<boolean | UrlTree>;

    return returnValue;
  }
}